






















import Vue from "vue";
import MenuBossComp from "./MenuBossComp.vue";
import _gamedata from "../../services/endpoints/gamedata";
import { Encounter } from "models/Encounter";

export default Vue.extend({
	name: "MenuWingComp",
	props: {
		showFC: Boolean,
	},
	components: { MenuBossComp },
	data: () => ({
		wings: {} as Encounter[][],
		strikes: {} as Encounter[][]
	}),
	methods: {
		pick: function(info: Encounter): void {
			this.$emit("pick", info);
		},
	},
	created: async function(): Promise<void> {
		this.wings = await _gamedata.listEncounterGrouped();
		this.strikes = await _gamedata.listEncounterGroupedStrikes();
	},
});
